import styled from "styled-components"

export const PaginationWrapper = styled.div`
    line-height: 50px;
    padding: 0 15px;
    float: right;
`
export const PageButton = styled.button<{
    isActive: boolean
}>`
    background: none;
    border: none;
    outline: none;
    font-family: ${(props) => props.theme.openSans};
    font-size: ${(props) => props.theme.fontSizes.xs}px;
    font-weight: 600;
    text-transform: uppercase;
    user-select: none;
    cursor: pointer;
    color: ${(props) => (props.isActive ? props.theme.tablePageButtonActiveColor : props.theme.tablePageButtonColor)};
`
export const PrevNextButton = styled(PageButton)`
    color: ${(props) => (props.isActive
        ? props.theme.tablePrevNextButtonColor
        : props.theme.tablePrevNextButtonInactiveColor)};

    & > i {
        padding: 0 5px;
    }
`
